import { PerlinNoiseGenerator } from "./PerlinNoiseGenerator.js";
export const perlinNoisePathName = "perlinNoise";
export async function loadPerlinNoisePath(engine, refresh = true) {
    await engine.addPathGenerator(perlinNoisePathName, new PerlinNoiseGenerator(), refresh);
}
